import React, { useState } from 'react';
import styles from './SFNavContentLink.module.scss';
import { SFChip, SFIcon, SFIconButton } from 'sfui';
import { SFNavLink } from '../../SFNavLink';
import { InteractiveBox } from 'ui-smartforce-settings';
import { useLocation } from 'react-router-dom';

export interface SFNavContentLinkProps {
  link: SFNavLink;
  isCollapsed?: boolean;
  isPanel?: boolean;
  disabled?: boolean;
  selected?: boolean;
  isChildren?: boolean;
  onDrawerClose?: () => void;
}

const SFNavContentLink = ({
  link,
  isCollapsed = false,
  isPanel,
  disabled = false,
  selected,
  isChildren = false,
  onDrawerClose
}: SFNavContentLinkProps): React.ReactElement<SFNavContentLinkProps> => {
  const location = useLocation();
  const [open, setOpen] = useState<boolean>(false);

  const onClick = (link: SFNavLink) => {
    link.onClick && link.onClick();
    onDrawerClose && onDrawerClose();
  };

  return (
    <div className={styles.container}>
      <InteractiveBox
        className={`${styles.link} ${selected ? styles.selected : ''}  ${
          disabled ? styles.disabled : ''
        } ${isChildren ? styles.isChildren : ''}`}
        onClick={() => onClick(link)}
      >
        {selected && !isChildren && <div className={styles.selectedBorder} />}

        {link.icon && (
          <SFIcon className={styles.icon} icon={link.icon} size={20} />
        )}
        {!isCollapsed && <span className={styles.label}>{link.label}</span>}
        {!isCollapsed && link.chip && (
          <span className={styles.chip}>
            <SFChip sfColor="primary" label={link.chip} size="small" />
          </span>
        )}

        {link.children && !isCollapsed && (
          <div className={styles.openBtn}>
            <SFIconButton
              sfSize={isPanel ? 'small' : 'tiny'}
              sfIcon={open ? 'Up-2' : 'Down-2'}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpen((o) => !o);
              }}
            />
          </div>
        )}
      </InteractiveBox>

      {link.children && link.children.length > 0 && open && !isCollapsed && (
        <ul className={styles.children}>
          {link.children.map((link: SFNavLink) => (
            <li key={`link-${link.label}`}>
              <SFNavContentLink
                link={link}
                selected={link.pathname === location.pathname}
                isChildren
                onDrawerClose={onDrawerClose}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SFNavContentLink;
